export default __webpack_public_path__ + "static/media/PDF_file_icon.a96115fc.png";